import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconArrowTriangleLeft"><Path d="M18.9146 4.07918C19.1471 3.96293 19.4232 3.97536 19.6443 4.11201C19.8654 4.24867 20 4.49007 20 4.75V19.25C20 19.5099 19.8654 19.7513 19.6443 19.888C19.4232 20.0246 19.1471 20.0371 18.9146 19.9208L4.41459 12.6708C4.1605 12.5438 4 12.2841 4 12C4 11.7159 4.1605 11.4562 4.41459 11.3292L18.9146 4.07918Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleLeft;
